import { Checkbox } from '@components/Checkbox';
import { ImageIcon } from '@src/assets';
import React from 'react';
import { Chip } from './Chip';
import { CheckboxGroup } from './styled/CheckboxGroup.styled';
import * as styled from './styled/SurroundingsGroup.styled';
import { TitleGroup } from './TitleGroup';

export const SurroundingsGroup: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
    return (
        <styled.SurroundingsGroup>
            <TitleGroup
                title="Surroundings"
                Icon={ImageIcon}
                Chip={<Chip label="optional" variant="caution" />}
            />
            <CheckboxGroup>
                <Checkbox disabled={disabled} name="isWaterfront" label="Waterfront" />
                <Checkbox disabled={disabled} name="isSkiInSkiOut" label="Ski-in/ski-out" />
            </CheckboxGroup>
        </styled.SurroundingsGroup>
    );
};
